import { atom } from "recoil";

export const gamesAddModalStore = atom({
	key: "gamesAddModalStore",
	default: {
		show: false,
		loaded: true,
		providerID: false,
		categoryID: [],
		section: [],
		badges: [],
		currentOption: {
			section: [],
			badges: [],
		},
		badgeAssignments: [],
		tags: [],
		metaTags: [],
		name: "",
		poster: "",
		volatility: 65,
		rtp: 95,
		params: [],
		newPoster: false,
		newBigPoster: false,
	},
});
